var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.806 3H9.705C9.54847 2.99987 9.39344 3.03057 9.24877 3.09035C9.1041 3.15014 8.97262 3.23783 8.86184 3.34842C8.75106 3.45902 8.66314 3.59035 8.60312 3.73492C8.54309 3.87949 8.51213 4.03447 8.512 4.191V9.5L19.581 12.75L30 9.5V4.191C29.9999 4.03438 29.9689 3.87932 29.9088 3.73469C29.8487 3.59005 29.7607 3.45868 29.6498 3.34807C29.5389 3.23746 29.4073 3.14979 29.2625 3.09007C29.1178 3.03034 28.9626 2.99974 28.806 3Z",
    fill: "#41A5EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 9.5H8.512V16L19.581 17.95L30 16V9.5Z",
    fill: "#2B7CD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.512 16V22.5L18.93 23.8L30 22.5V16H8.512Z",
    fill: "#185ABD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.705 29H28.805C28.9617 29.0004 29.1169 28.9699 29.2618 28.9102C29.4067 28.8506 29.5385 28.7629 29.6495 28.6523C29.7605 28.5417 29.8485 28.4102 29.9087 28.2655C29.9688 28.1208 29.9999 27.9657 30 27.809V22.5H8.512V27.809C8.51213 27.9655 8.54309 28.1205 8.60312 28.2651C8.66314 28.4097 8.75106 28.541 8.86184 28.6516C8.97262 28.7622 9.1041 28.8499 9.24877 28.9096C9.39344 28.9694 9.54847 29.0001 9.705 29Z",
    fill: "#103F91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.434 8.20001H8.512V24.45H16.434C16.7497 24.4484 17.052 24.3226 17.2755 24.0996C17.499 23.8767 17.6256 23.5747 17.628 23.259V9.39101C17.6256 9.07535 17.499 8.77333 17.2755 8.5504C17.052 8.32747 16.7497 8.20158 16.434 8.20001Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.783 8.84998H8.512V25.1H15.783C16.0987 25.0984 16.401 24.9725 16.6245 24.7496C16.848 24.5267 16.9746 24.2246 16.977 23.909V10.041C16.9746 9.72531 16.848 9.4233 16.6245 9.20037C16.401 8.97743 16.0987 8.85155 15.783 8.84998Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.783 8.84998H8.512V23.8H15.783C16.0987 23.7984 16.401 23.6725 16.6245 23.4496C16.848 23.2267 16.9746 22.9246 16.977 22.609V10.041C16.9746 9.72531 16.848 9.4233 16.6245 9.20037C16.401 8.97743 16.0987 8.85155 15.783 8.84998Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.132 8.84998H8.512V23.8H15.132C15.4477 23.7984 15.75 23.6725 15.9735 23.4496C16.197 23.2267 16.3236 22.9246 16.326 22.609V10.041C16.3236 9.72531 16.197 9.4233 15.9735 9.20037C15.75 8.97743 15.4477 8.85155 15.132 8.84998Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.194 8.84998H15.132C15.4482 8.84971 15.7516 8.97501 15.9755 9.19834C16.1994 9.42166 16.3255 9.72475 16.326 10.041V21.959C16.3255 22.2752 16.1994 22.5783 15.9755 22.8016C15.7516 23.0249 15.4482 23.1502 15.132 23.15H3.194C3.03738 23.1502 2.88224 23.1196 2.73746 23.0599C2.59267 23.0002 2.46108 22.9125 2.35019 22.8019C2.2393 22.6913 2.1513 22.5599 2.09121 22.4153C2.03113 22.2707 2.00013 22.1156 2 21.959V10.041C2.00013 9.88436 2.03113 9.7293 2.09121 9.58466C2.1513 9.44003 2.2393 9.30865 2.35019 9.19804C2.46108 9.08744 2.59267 8.99977 2.73746 8.94004C2.88224 8.88032 3.03738 8.84971 3.194 8.84998Z",
    fill: "url(#paint0_linear_411_37)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9 17.988C6.923 18.172 6.939 18.332 6.946 18.469H6.974C6.984 18.339 7.006 18.182 7.039 17.999C7.072 17.816 7.101 17.661 7.128 17.534L8.383 12.127H10.007L11.307 17.453C11.3827 17.7824 11.4368 18.1165 11.469 18.453H11.491C11.5149 18.1254 11.56 17.7997 11.626 17.478L12.665 12.12H14.142L12.318 19.868H10.591L9.354 14.742C9.318 14.594 9.27733 14.4013 9.232 14.164C9.18667 13.9267 9.15866 13.7533 9.148 13.644H9.127C9.113 13.77 9.085 13.957 9.043 14.205C9.001 14.454 8.968 14.637 8.943 14.757L7.78 19.871H6.024L4.19 12.127H5.69L6.821 17.545C6.85475 17.6912 6.88112 17.8391 6.9 17.988Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_411_37",
    x1: 4.494,
    y1: 7.91398,
    x2: 13.832,
    y2: 24.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2368C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1A5DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1146AC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.811795f1987870b03ab8a97105d1c64a.svg";
export { ForwardRef as ReactComponent };